<div class="dialog-content">
  <img class="alert-logo" [src]="imgPath" />
  <button class="material-icons close close-btn" (click)="closeModel()">close</button>
  <ng-container *ngIf="this.data.type=='creditCard'">
    <div class="make-payment">
      <div>
        <h3 class="content_center payment">
          {{payInfoTitle[data.type]}}
        </h3>
      </div>
      <div>
        <div [formGroup]="amountControl" class="flex_row mt-1">
          <mat-form-field class="name_input me-2" appearance="outline" floatLabel="always"
                  [hideRequiredMarker]="false">
            <mat-label>Amount ({{paymentDetails.transaction_currency}})</mat-label>
            <input [min]="minStripeLimit" style="height: auto" matInput required type="number" disableScrollOnNumber [max]="maxStripeLimit"
                formControlName="entries"
                (keyup)="validate()" placeholder="Enter Amount" [(ngModel)]="paymentDetails.amount"
                (blur)="paymentDetails.amount != null && paymentDetails.amount >=1 ? getTotalAmount():''"/>
            <mat-error *ngIf="amountControl.hasError('min', 'entries')" >
              Minimum value of amount is {{minStripeLimit}}
            </mat-error>
            <mat-error *ngIf="amountControl.hasError('max', 'entries')" >
                Maximum value of amount is {{maxStripeLimit}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="flex_row">
          <mat-form-field class="name_input unset_txt_area_hght me-3" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
            <mat-label>Description</mat-label>
            <textarea style="height: auto" required [maxlength]="200" rows="4" placeholder="Please enter description" matInput type="text" [(ngModel)]="paymentDetails.description" (keyup)="validate()">
            </textarea>
            <mat-hint align="end">{{paymentDetails.description.length || 0}} / 200</mat-hint>
            <mat-error> Description is required. </mat-error>
          </mat-form-field>
        </div>
        <div class="flex_row">
          <ng-container *ngIf="this.data.currency == 'USD'">
            <p>Payment Currency:</p>
            <p><b>{{paymentDetails.transaction_currency}}</b></p>
          </ng-container>
          <ng-container *ngIf="this.data.currency != 'USD'">
            <mat-form-field class="me-3" appearance="outline" floatLabel="always" [hideRequiredMarker]="false">
              <mat-label>Payment Currency</mat-label>
              <mat-select required [(ngModel)]="paymentDetails.transaction_currency"
               (selectionChange)="fetchStripeLimit();paymentDetails.amount != null && paymentDetails.amount >=1 ?getTotalAmount():''">
                <mat-option class="green-checkbox" *ngFor="let item of currencyOptions " [value]="item.value">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </div>
        <ng-container *ngIf="payableAmountAvailable && paymentDetails.amount >= 1">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Total Payable Amount:
                </mat-panel-title>
                <mat-panel-description>
                  {{this.totalPayableAmount.total_amount | currency : this.totalPayableAmount.currency }}
                </mat-panel-description>
              </mat-expansion-panel-header>
              <p>Charges Break-up:</p>
              <table class="payable-amount-table">
                <tr>
                  <td>Recharge Amount</td>
                  <td>{{this.totalPayableAmount.amount | currency : this.totalPayableAmount.currency}}</td>
                <tr>
                  <tr>
                    <td>Card processing charges</td>
                    <td>{{this.totalPayableAmount.pg_charges | currency : this.totalPayableAmount.currency}}</td>
                  <tr>
              </table>
            </mat-expansion-panel>
          </mat-accordion>
        </ng-container>
        <div>
            <div class="col-md-12 mt-1" align="left">
              <div class="row mt-1">PLEASE NOTE:</div>
            </div>
            <ol class="col-md-12 mt-1" align="left">
              <li class="row" style="color: var(--brand-color)">
                1. If your organization address (in {{platformName}}) is in the US and you are making a USD payment, card processing charges of 2.9% + US $0.30 will be added to your payment.
              </li>
              <li class="row" style="color: var(--brand-color)">
                2. If your organization address (in {{platformName}}) is outside the US and you are making a USD payment, card processing charges of 4.5% + US $0.30 will be added to your payment.
              </li>
              <li class="row" style="color: var(--brand-color)">
                3. If you are making a non USD payments, card processing charges of 3.9% + US $0.30 will be added to your payment.
              </li>
              <li class="row" style="color: var(--brand-color)">
                4. If you are using an International card to pay in a currency (eg: USD) that is different to the card’s default currency (eg: GBP), an additional 1% charge will be calculated on gross amount and debited from your {{platformName}} account offline.
              </li>
              <li class="row">
                5. On clicking the Pay button, you will be redirected to a
                payment gateway page where you will be required to enter your
                credit card information.
              </li>
              <li class="row">
                6. {{creditForName}} does not store your credit card information.
              </li>
            </ol>
        </div>
        <div class="content_center">
          <span>
            <mat-checkbox [(ngModel)]="isAgreed" (change)="validate()" class="ms-3">
              I agree on
              <span matTooltip="Click to see Terms and Conditions" (click)="openTnc()" style="color: blue">
                Terms and Conditions
              </span>
            </mat-checkbox>
          </span>
        </div>
        <div class="row content_center">
          <div class="col-md-3">
            <span class="content_center">
              <button (click)="createPgsession()" [disabled]="!isValid" mat-button [ngClass]="{'create-btn-disabled': !isValid,'create-btn': true}" >
                Pay
              </button>
            </span>
          </div>
        </div>
      </div>
  </div>
  </ng-container>

  @if(data.type != 'creditCard') {
    <h3 class="content_center payment">{{ payInfoTitle[data.type] }}</h3>

    <div class="instruction-banner">
      {{nonCardPayInfo[data.type]}}
    </div>

    <table class="wire-table">
      <tbody>
        @for (detail of nonCardPayDetails[data.type]; track detail.label) {
        <tr>
          <td class="wire-lbl">{{ detail.label }}</td>
          <td class="wire-val" [class.mono]="detail.mono">
            @for (line of detail.value.split('\n'); track $index) { {{ line }}<br />
            }
          </td>
        </tr>
        }
      </tbody>
    </table>

    <div class="wire-note">
      <span>
        Please mail {{data.type == 'ach'? 'ACH': 'wire'}} transfer transaction details to
        <a [href]="'mailto:' + payeeEmail">{{ payeeEmail }}</a>
        and your {{platformName}} account will be credited post verification of payment by
        our team.
      </span>
    </div>
  }
</div>
